﻿const MAX_ZIP_SIZE_MB = 200;
const MAX_ZIP_SIZE_BYTES = MAX_ZIP_SIZE_MB * 1024 * 1024;
const ZIP_EXT = '.zip';
const ALLOWED_MIME = new Set([
  'application/zip',
  'application/x-zip-compressed',
  '',
]);

export function validateZipFile(file: File): { ok: true } | { ok: false; error: string } {
  const name = file.name?.toLowerCase() ?? '';
  const type = (file.type ?? '').toLowerCase();

  if (!name.endsWith(ZIP_EXT)) {
    return { ok: false, error: 'Файл должен быть в формате ZIP' };
  }

  if (!ALLOWED_MIME.has(type)) {
    return { ok: false, error: 'Файл должен быть в формате ZIP' };
  }

  if (file.size > MAX_ZIP_SIZE_BYTES) {
    return { ok: false, error: `Файл слишком большой (максимум ${MAX_ZIP_SIZE_MB} МБ)` };
  }

  return { ok: true };
}
